export default __webpack_public_path__ + "static/media/whatsappSlide5.ee1fc919.svg";